const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");
const moment = require("moment");

const OpsSchool = require("./vault/OpsSchool");
const InfoIcon = require("../office/InfoIcon");
const CopyTable = require("./data/CopyTable");
const RosteringBody = require("./RosteringBody");
const URLMake = require("../../shared/URLMake");
const Link = require("../core/view/Link");

const AddSeats = require("./AddSeats");

const {ACADEMY_PURCHASE_ID} = require("../../shared/Constants");

const styles = require("./styles/PurchaseManage.css");

module.exports = createReactClass({
	displayName: "AccountsSubscription",

	propTypes: {
		user: PT.object.isRequired,
		schoolState: PT.object.isRequired,
	},

	makeLabel(copyType, labelText) {
		const copy = CopyTable.getSystemManageCopy(copyType);
		return (
			<div className={styles.label}>
				<InfoIcon
					title={copy.title}
					text={copy.description}
					isModal={true}
					className={styles.info}
				/>
				{copy.title}
			</div>
		);
	},

	renderSubscription() {
		const {schoolState} = this.props;
		const purchase = _.get(schoolState, "accounts.purchase");
		const {studentLimit, teacherLimit, rolloverAt, classesEndAt} = purchase;
		const numStudents = OpsSchool.getStudentCount(schoolState);
		const numTeachers = OpsSchool.getStaffCount(schoolState);
		const scheduledRolloverAt = OpsSchool.getScheduledPurchaseRolloverDate(
			schoolState
		);
		const displayedRolloverAt = scheduledRolloverAt
			? scheduledRolloverAt
			: rolloverAt;
		return (
			<div className={styles.upper}>
				<div className={styles.section}>
					<div className={styles.sectionItem}>
						{this.makeLabel("studentLimit")}
						<div className={purchase.expiredAt ? "" : styles.limitWithButton}>
							{`${numStudents} / ${studentLimit || "unlimited"}`}
							{purchase.expiredAt ? "" : <AddSeats purchaseInfo={purchase} />}
						</div>
					</div>
					<div className={styles.sectionItem}>
						{this.makeLabel("teacherLimit")}
						<div className={styles.limitWithButton}>
							{`${numTeachers} / ${teacherLimit || "unlimited"}`}
							{purchase.expiredAt ? (
								""
							) : (
								<div className={styles.noEditLimitButton} />
							)}
						</div>
					</div>
				</div>
				<div className={styles.section}>
					<div className={styles.sectionItem}>
						{this.makeLabel("rolloverAt")}
						{`${
							displayedRolloverAt
								? moment.utc(displayedRolloverAt).format("YYYY-MM-DD")
								: "none"
						}`}
					</div>
					<div className={styles.sectionItem}>
						{this.makeLabel("classesEndAt")}
						{`${
							classesEndAt
								? moment.utc(classesEndAt).format("YYYY-MM-DD")
								: "none"
						}`}
					</div>
				</div>
			</div>
		);
	},

	renderRostering: function() {
		return (
			<div className={styles.rostering}>
				<div className={styles.rosteringContent}>
					<div className={styles.rosteringHeader}>Create Users and Classes</div>
					<div className={styles.rosteringDescription}>
						{CopyTable.getRosteringCopy()}
					</div>
					<div className={styles.rosteringBody}>
						<RosteringBody
							user={this.props.user}
							schoolState={this.props.schoolState}
						/>
					</div>
				</div>
			</div>
		);
	},

	render() {
		const {schoolState} = this.props;
		let bottomEl;
		const purchaseID = _.get(schoolState, ["accounts", "purchase", "id"]);
		if (
			purchaseID !== ACADEMY_PURCHASE_ID &&
			!_.get(schoolState, ["accounts", "purchase", "expiredAt"], null)
		) {
			bottomEl = this.renderRostering();
		}
		return (
			<div className={styles.main}>
				<div className={styles.sectionTitle}>General Information</div>
				{this.renderSubscription()}
				<div className={styles.helpText}>
					<Link
						to={URLMake.forSchoolSupport("rostering")}
						className={styles.helpLink}
						isNewTab={true}
					>
						{"Need help? Check out our Help Site."}
					</Link>
				</div>
				{bottomEl}
			</div>
		);
	},
});
